/**
 * The registry's columns the server sorts, by column id: the `list_filter.sort_by`
 * name ListJobs orders that column's value by. A column missing here does not sort —
 * the registry lists one page at a time, so a client sort would order only the
 * rows loaded so far.
 */
export const REGISTRY_SORT_BY: Readonly<Record<string, string>> = {
  number: "id",
  author: "author",
  aiVisibility: "ai_visible",
  statusText: "status",
  incident: "incident",
  typeText: "type",
  planCount: "planned_containers",
  factCount: "fact_containers",
  factVolume: "fact_volume",
  container_type: "container_type",
  customer: "customer",
  objectName: "pickup_location",
  priorityText: "priority",
  geozone: "geozone",
  route: "route",
  tw_start: "tw_start_at",
  createdAt: "created_at",
  finishedAt: "fact_end_at",
  hasPhotoReport: "photo",
  tariff: "tariff",
  plateNumber: "plate",
  driverName: "driver",
  comment: "comment",
};
